export const AMPLITUDE_API_KEY =
  process.env.REACT_APP_AMPLITUDE_API_KEY || '8673dbc4059af7cf59b43685d7126e5c';

// DEV_NOTE: once proxy server is confirmed working, this will be added back in
// export const AMPLITUDE_SERVER_URL =
//   process.env.REACT_APP_AMPLITUDE_SERVER_URL ||
//   'https://events.kanda.co.uk/2/httpapi';

export const AMPLITUDE_SERVER_URL =
  process.env.REACT_APP_AMPLITUDE_SERVER_URL ||
  'https://api2.amplitude.com/2/httpapi';

export const AMPLITUDE_STORAGE_KEY =
  process.env.REACT_APP_AMPLITUDE_STORAGE_KEY || 'amplitude-kanda-ids';

export const APP_ENV = process.env.REACT_APP_ENV || 'qa';
